// src/utils/pedidoUtils.js
export const usaIdDiaPedido = (configModulo) => {
  if (!configModulo) return true;

  if (typeof configModulo.usaIdDia === 'boolean') {
    return configModulo.usaIdDia;
  }

  if (typeof configModulo.UsaIdDia === 'boolean') {
    return configModulo.UsaIdDia;
  }

  return true;
};

export const getNumeroPedido = (pedido, configModulo) => {
  if (!pedido) return '';

  const numeroIdDia = pedido.idDia ?? pedido.pedidoIdDia;
  const numeroId = pedido.id ?? pedido.pedidoId;

  return usaIdDiaPedido(configModulo) ? (numeroIdDia ?? numeroId ?? '') : (numeroId ?? numeroIdDia ?? '');
};
